<template>
  <div>
    <h5 class="text-center" v-html="translatedFields['please_input_code_provided_to_you']"></h5>
    <div class="row">
      <div class="col-md-10 col-md-offset-1">
        <div class="form-group">
          <form @submit.prevent="validate(true)">
            <label class="control-label"
                    v-html="translatedFields['office_employer_code']">
            </label>
            <input class="form-control"
                  data-vv-as="Office location code"
                  id="site-code"
                  type="text"
                  name="siteCode"
                  v-validate="modelValidations.siteCode"
                  v-model="model.siteCode"
                  placeholder="ex: 12345678"
            />
          </form>
          <small class="text-danger" v-show="siteCode.invalid">
            {{ getError('siteCode') }}
          </small>
        </div>
      </div>
    </div>
    <div class="col-md-2 pl-0">
      <language-button id="mobile-language"></language-button>
    </div>
  </div>
</template>
<script>
  import {mapFields} from 'vee-validate'
  import axios from 'axios'
  import LanguageButton from '../../LanguageButton'
  export default {
    components: {
      LanguageButton
    },
    data () {
      return {
        translatedFields: '',
        fields_en: {
          please_input_code_provided_to_you: 'Please input the Location Code provided to you',
          office_employer_code: 'Office Location Code'
        },
        model: {
          siteCode: null
        },
        modelValidations: {
          siteCode: {
            min: 5,
            required: true
          }
        },
        allow_client_bill: String(process.env.ALLOW_CLIENT_BILL) === 'true'
      }
    },
    mounted () {
      if (this.$route.query.site_code) {
        this.model.siteCode = this.$route.query.site_code
        this.validate(true)
      }
    },
    methods: {
      checkLanguage () {
        if (this.$store.state.lang.value === 'ES') {
          this.translatedFields = this.$store.state.translation_es
        } else {
          if (this.$store.state.lang.value === 'ZH') {
            this.translatedFields = this.$store.state.translation_zh
          } else {
            this.translatedFields = this.fields_en
          }
        }
      },
      getError (fieldName) {
        return this.errors.first(fieldName)
      },
      jumpToTheNextPage () {
        this.$emit('jumpToTheNextPage')
      },
      validate (nextPage) {
        return new Promise((resolve, reject) => {
          this.model.validatedSiteCode = null
          axios.get(process.env.SERVER_URI + '/validate/site/' + this.model.siteCode).then(async (response) => {
            if (response.data === false) {
              this.$validator.errors.add({field: 'siteCode', msg: 'Invalid Code!'})
              let field = this.$validator._resolveField('siteCode')
              field.setFlags({invalid: true})
              reject(new Error('Invalid site code!!'))
            } else {
              this.$store.state.site = response.data
              if (response.data['logo']) {
                this.$store.state.logo = response.data['logo']
              }
              if (response.data['allow_payment'] === false) {
                this.$store.state.cashPayment = 'false'
                this.$store.state.billingType = ''
              } else {
                this.$store.state.cashPayment = 'true'
                this.$store.state.billingType = 'card'
              }
              // process.env.NODE_ENV = 'testing'
              let one = process.env.SERVER_URI + '/gender/' + this.model.siteCode
              let two = process.env.SERVER_URI + '/ethnicity/' + this.model.siteCode
              let three = process.env.SERVER_URI + '/race/' + this.model.siteCode
              let four = process.env.SERVER_URI + '/questions/' + this.model.siteCode

              const requestOne = axios.get(one)
              const requestTwo = axios.get(two)
              const requestThree = axios.get(three)
              const requestFour = axios.get(four)
              await axios.all([requestOne, requestTwo, requestThree, requestFour])
                  .then(axios.spread((...responses) => {
                    this.$store.state.gender = responses[0].data
                    this.$store.state.ethnicity = responses[1].data
                    this.$store.state.race = responses[2].data
                    this.$store.state.questions = responses[3].data
                  })).catch(errors => {
                    console.log('Error' + errors)
                  })
              if (nextPage) {
                this.jumpToTheNextPage()
              }
            }
            resolve(true)
          }).catch(() => {
            this.$validator.errors.add({field: 'siteCode', msg: 'Invalid Code or server issues!'})
            let field = this.$validator._resolveField('siteCode')
            field.setFlags({invalid: true})
            reject(new Error('Invalid site code!!'))
          })
        })
      }
    },
    computed: {
      ...mapFields(['siteCode']),
      language () {
        this.checkLanguage()
        return this.$store.state.lang.value
      },
      spanishFields () {
        return this.$store.state.translation_es
      },
      chineseFields () {
        return this.$store.state.translation_zh
      },
      ...mapFields(['siteCode'])
    },
    watch: {
      language () {
        this.checkLanguage()
      }
    }
  }
</script>
<style scoped>

  #site-code{
    text-transform: uppercase;
  }

  >>> .language{
    margin: 0px !important;
    margin-top: 10px !important;
  }

  @media (max-width: 992px){
    #mobile-language{
      display: none;
    }
  }

  .pl-0{
    padding-left: 0px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Homekit/Wizard/SiteSelectionStep.vue